// Constantes da configuração de avaliação por conceito.
// Fonte única usada pelos editores da tela "Configurações do Sistema" (parametros-sistema).
// As chaves correspondem aos parâmetros globais em parametros_sistema (categoria 'avaliacao').

export const CHAVE_AVALIACAO_METODO = 'avaliacao.metodo'
export const CHAVE_AVALIACAO_CONCEITO_MODO = 'avaliacao.conceito_modo'
export const CHAVE_AVALIACAO_CONCEITO_ID = 'avaliacao.conceito_id'
export const CHAVE_AVALIACAO_CONCEITO_GRANULARIDADE = 'avaliacao.conceito_granularidade'

// Método global de avaliação. 'quantitativo' = comportamento atual (nota geral); 'conceito' = novo.
export const METODO_AVALIACAO = [
    { v: 'quantitativo', l: 'Quantitativo (nota geral)' },
    { v: 'conceito',     l: 'Conceito' }
]

// Modo do lançamento de conceito.
export const CONCEITO_MODO = [
    { v: 'geral',       l: 'Geral (um conceito por disciplina/período)' },
    { v: 'competencia', l: 'Por competência (um conceito por critério)' }
]

// Granularidade do lançamento de conceito.
export const CONCEITO_GRANULARIDADE = [
    { v: 'unico',    l: 'Único (um conceito por período)' },
    { v: 'multiplo', l: 'Múltiplo (várias avaliações por período + conceito final)' }
]

// Modo de lançamento da frequência no diário (parâmetro global 'diario.frequencia_modo', categoria 'diario').
// Usa o mesmo editor de opção fixa (avaliacao-select-editor) da tela de Configurações do Sistema.
export const CHAVE_DIARIO_FREQUENCIA_MODO = 'diario.frequencia_modo'

export const FREQUENCIA_MODO = [
    { v: 'diaria',  l: 'Chamada diária' },
    { v: 'periodo', l: 'Total por período/bimestre' }
]

// Modo de lançamento das notas no diário (parâmetro global 'diario.nota_modo', categoria 'diario').
// Usa o mesmo editor de opção fixa (avaliacao-select-editor) da tela de Configurações do Sistema.
export const CHAVE_DIARIO_NOTA_MODO = 'diario.nota_modo'

export const NOTA_MODO = [
    { v: 'atividades',    l: 'Por atividades — soma das avaliações' },
    { v: 'media_periodo', l: 'Média do bimestre — por turma/por disciplina' }
]

// Método de avaliação por curso (série) — parâmetro json 'diario.metodo_avaliacao_por_curso',
// valor {"<curso_id>": "quantitativo" | "qualitativo"}. Editado em metodo-avaliacao-curso-editor.vue.
export const CHAVE_DIARIO_METODO_AVALIACAO_POR_CURSO = 'diario.metodo_avaliacao_por_curso'
